export const DOCUMENT_FALLBACKS = {
  unknown: 'UNKNOWN',
  tbd: 'TBD',
  notProvided: 'Not provided',
  pending: 'Pending',
  contactDispatcher: 'Contact dispatcher',
  notAssigned: 'Not assigned',
  missing: 'Missing',
} as const

export type DocumentFallbackKey = keyof typeof DOCUMENT_FALLBACKS
